import { Table } from "@/features/Table";
import { type Transaction, transactions_columns } from "./columns";
import { type FilterTransactionsSchema, FilterTransactions } from "./filter";
import { useLocation } from "react-router-dom";

const client = "legacy-quantilia";
const table_name = "transactions";

export const TransactionsTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<Transaction, FilterTransactionsSchema>
      label="Financial Transactions"
      client={client}
      table_name={table_name}
      columns={transactions_columns}
      filter={<FilterTransactions />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
